import * as yup from 'yup';

export const initialValues = {
  userName: '',
  userFullName: '',
  email: '',
  roleId: '',
  password: '',
  employeeId: '',
  isActive: '',
  hrCoCd: '',
  adAuthentication: false,
  canViewOtherEmp: false,
  employeeImageUrl: '',
  isDefaultDashboard: '',
  isDefaultCompany: false,
  canViewSelfService: false,
  canViewHR: false,
  finCoCd: '',
  deviceType: '',
  tokenFCM: '',
  isTwoFactor: false,
  companyList: [],
  defaultCompanyCode: '',
  canViewDashboard: [],
  isDefaultCompanies: [],
};

export const validationSchema = yup.object().shape({
  userName: yup.string().required('Login Name is required'),
  userFullName: yup.string().required('User Full Name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  roleId: yup.string().required('Role is required'),
  password: yup.string().required('Password is required'),
  employeeId: yup.string().optional(),
  isActive: yup
    .string()
    .oneOf(['true', 'false'], 'Status must be Active or Inactive')
    .required('Status is required'),
  hrCoCd: yup.string().required('HR Company is required'),
  adAuthentication: yup.boolean(),
  canViewOtherEmp: yup.boolean(),
  isDefaultDashboard: yup
    .string()
    .oneOf(['S', 'H'], 'Select a valid default dashboard'),
  canViewDashboard: yup
    .array()
    .of(yup.string())
    .min(1, 'Select at least one value')
    .required('Select at least one value'),
  isDefaultCompanies: yup
    .array()
    .of(
      yup.object().shape({
        companyCode: yup.string().required(),
        companyName: yup.string().required(),
        isAllowed: yup.boolean(),
        isDefaultCompany: yup.boolean(),
      }),
    )
    .test(
      'at-least-one-allowed',
      'At least one company must be selected',
      value => Array.isArray(value) && value.some(company => company.isAllowed),
    )
    .test(
      'one-default-company',
      'Select one default company',
      value =>
        Array.isArray(value) &&
        value.filter(company => company.isDefaultCompany).length === 1,
    ),
});

export const defaultDashboard = [
  { label: 'Self-Service', value: 'S' },
  { label: 'HR', value: 'H' },
];

export const userStatusOptions = [
  { label: 'Active', value: 'true' },
  { label: 'Inactive', value: 'false' },
];
